import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreateUserDocument, UserDocument } from 'Pages/profile'

export type UserDocumentsState = {
	documents: UserDocument[]
}

const initialState: UserDocumentsState = {
	documents: [],
}

export namespace UserDocumentsNS {
	export type GetAll = PayloadAction
	export type SetAll = PayloadAction<UserDocument[]>
	export type CreateOne = PayloadAction<CreateUserDocument>
	export type DeleteOne = PayloadAction<number>
}

export const userDocumentsSlice = createSlice({
	name: 'user_documents',
	initialState,
	reducers: {
		getAll: (state, action: UserDocumentsNS.GetAll) => {},
		setAll: (state, action: UserDocumentsNS.SetAll) => {
			state.documents = action.payload
		},
		createOne: (state, action: UserDocumentsNS.CreateOne) => {},
		deleteOne: (state, action: UserDocumentsNS.DeleteOne) => {},
	},
})
